<template>
  <aside class="lesson-lessons-list p-4 shadow">
    <search v-model="searchTerm" class="mb-4" />

    <div class="desktop-scroll">
      <template v-if="searchTerm">
        <lesson-link
          v-for="lesson in lessons"
          :key="'w' + lesson.id"
          :lesson="lesson"
        />
      </template>

      <template v-if="!searchTerm">
        <lesson-link
          v-for="lesson in lessonsWithoutModule"
          :key="'w' + lesson.id"
          :lesson="lesson"
        />

        <div class="mr-4" v-for="module in modules" :key="'m' + module.id">
          <button
            class="card module mt-4 mb-2 w-100"
            :class="{ opened: openedModules.includes(module.id) }"
            @click="toggleModule(module.id)"
          >
            <div class="card-body d-flex align-items-center w-100">
              <span class="flex-fill pr-2">{{ module.name }}</span>
              <i class="icon-chevron-right"></i>
            </div>
          </button>

          <transition name="fade" :duration="100">
            <div v-if="openedModules.includes(module.id)">
              <lesson-link
                v-for="lesson in module.lessons"
                :key="'l' + lesson.id"
                :lesson="lesson"
              />
            </div>
          </transition>
        </div>
      </template>
    </div>
  </aside>
</template>

<script>
import Search from "./Search";
import LessonLink from "./LessonLink";
import get from "lodash/get";

export default {
  components: { Search, LessonLink },
  props: {
    course: {
      type: Object,
      required: true
    },
    lesson: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    const currentModule = get(this.lesson, "module.id");

    return {
      openedModules: currentModule ? [currentModule] : [],
      searchTerm: ""
    };
  },
  computed: {
    lessons() {
      return this.course.lessons.filter(
        item =>
          item.name.toLowerCase().indexOf(this.searchTerm.toLowerCase()) >= 0
      );
    },
    lessonsWithoutModule() {
      return this.lessons.filter(lesson => !get(lesson, "module.id"));
    },
    modules() {
      return get(this.course, "modules", [])
        .slice()
        .sort((a, b) => a.order - b.order)
        .map(module => ({
          ...module,
          lessons: this.lessons.filter(
            lesson => module.id === get(lesson, "module.id")
          )
        }));
    }
  },
  methods: {
    toggleModule(id) {
      if (this.openedModules.includes(id)) {
        this.openedModules.splice(this.openedModules.indexOf(id), 1);
      } else {
        this.openedModules.push(id);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.lesson-lessons-list {
  background: black;

  @media screen and (min-width: 992px) {
    width: 30%;
    min-width: 300px;
    min-height: calc(100vh - 56px);
    max-height: calc(100vh - 56px);
    display: flex;
    flex-direction: column;
    position: sticky;
    top: 56px;

    .desktop-scroll {
      flex: 1 1 auto;
      overflow-y: scroll;

      // -ms-overflow-style: none;
      // scrollbar-width: none;
      &::-webkit-scrollbar {
        // display: none;
      }
    }
  }

  .card {
    border-right: none;
    border-left: none;
    background: transparent;
    text-align: left;
    font-size: 14px;
    background: rgb(20, 20, 20);
    border: none;
    font-weight: bold;

    &:hover {
      background: rgba(20, 20, 20, 0.7);
    }

    &.module {
      font-size: 18px;
      background: rgb(64, 64, 64);

      &:hover {
        background: rgba(64, 64, 64, 0.7);
      }
    }

    .icon-chevron-right {
      transition: all 0.2s;
    }

    &.opened {
      .icon-chevron-right {
        transform: rotate(90deg);
      }
    }
  }
}
</style>
